<template>
  <div class="no-ai-mark" :class="{ 'no-ai-mark--with-label': Boolean(label) }">
    <div class="no-ai-mark__icon" aria-hidden="true">
      <v-icon class="no-ai-mark__robot" :size="robotSize" color="#1d3557">
        mdi-robot-outline
      </v-icon>
      <v-icon class="no-ai-mark__ban" :size="banSize" color="#c62828">mdi-cancel</v-icon>
    </div>
    <span v-if="label" class="no-ai-mark__label">{{ label }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeNoAiMark',

  props: {
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String as () => 'md' | 'sm',
      default: 'md',
    },
  },

  computed: {
    robotSize(): number {
      return this.size === 'sm' ? 18 : 28
    },
    banSize(): number {
      return this.size === 'sm' ? 28 : 44
    },
  },
})
</script>

<style scoped>
.no-ai-mark {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.no-ai-mark__icon {
  position: relative;
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #ff9f1c;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}

.no-ai-mark--with-label .no-ai-mark__icon {
  width: 34px;
  height: 34px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
}

.no-ai-mark__robot {
  position: relative;
  z-index: 0;
  opacity: 0.9;
}

.no-ai-mark__ban {
  position: absolute;
  inset: 0;
  margin: auto;
  z-index: 1;
  filter: drop-shadow(0 1px 1px rgba(255, 255, 255, 0.55));
}

.no-ai-mark__label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #1d3557;
  line-height: 1.15;
  white-space: nowrap;
}
</style>
